<template>
    <transition name="fade">
        <div
            v-if="show"
            class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
        >
            <div
                class="rounded-2xl border-[8px] relative modal-background w-[90%] border-[] rounded-[26px] w-[80%] p-2 text-white shadow-xl transform animate-[fadeIn_0.3s_ease-out_forwards]">
                <img
                    src="https://www.burma368.net/static/image/common/popup-icon.png"
                    alt="icon"
                    class="w-[160px] h-[84px] absolute top-[-80px] left-[50%] translate-x-[-50%]"
                />
                <div class="my-auto pt-4 px-4 pb-4 w-full">
                    <b-carousel
                        :interval="3000"
                        controls
                        fade
                        class="popup-carousel"
                    >
                        <b-carousel-slide
                            v-for="(banner, index) in banners"
                            :key="index"
                            :img-src="banner"
                        ></b-carousel-slide>
                    </b-carousel>

                    <div class="mt-3 d-flex flex-column">
                        <div class="mx-auto mb-3">
                            <div class="d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    v-model="isHideForToday"
                                    class="mr-2"
                                    id="hide"
                                />
                                <label
                                    class="text-white text-center m-0"
                                    for="hide"
                                >{{ $t('promotion.hide_today') }}</label>
                            </div>
                        </div>

                        <button
                            class="close-btn"
                            @click="handleClose"
                        >
                            {{ $t('close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </transition>
</template>

<script>
export default {
    name: "PromoPopup",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        banners: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isHideForToday: false,
        };
    },
    methods: {
        handleClose() {
            if (this.isHideForToday) {
                const today = new Date().toISOString().split("T")[0];
                localStorage.setItem("hidePopupDate", today);
            }
            this.$emit("close");
        },
    },
    mounted() {
        const today = new Date().toISOString().split("T")[0];
        const saved = localStorage.getItem("hidePopupDate");
        if (saved === today) {
            this.$emit("close");
        }
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

/* === close button === */
.close-btn {
    background: linear-gradient(to right, #924aff, #4f3ffd);
    color: #fff;
    border: none;
    border-radius: 9999px;
    padding: 10px 0;
    font-size: 20px;
    width: 100%;
    font-weight: 500;
    transition: all 0.3s ease;
}

.close-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(79, 63, 253, 0.4);
}
</style>
